import { EditableCard } from "../../../components/editableCard.component";
import { AppRouteUi } from "../../../config/appRoute";
import { ApiSchemaPatient } from "../../../models/api";
import { CaregiverList } from "../../caregiver/caregiverList.component";

type Props = {
  data: ApiSchemaPatient | undefined;
  isValidating: boolean;
};

export const PatientCaregiverList = (props: Props) => {
  return (
    <EditableCard
      link={`${AppRouteUi.Patient.Root()}/update/${props.data?.sKey}`}
      title="Caregiver List"
      isValidating={props.isValidating}
    >
      <CaregiverList
        data={props.data?.caregivers ?? []}
        isValidating={props.isValidating}
        isInProfile
      />
    </EditableCard>
  );
};
